export default __webpack_public_path__ + "assets/youtube_video_widget.6ecd5e9b40ecfb9559d69431f36850d3.svg";